var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAChklEQVR4Ae3YS8iMURzH8Y9rLitKKZed2FlJJBuxdNmwRlm4RNkROytWFmxY2chCiiUbpcjCTrmsiCyIFLmFjuap6W3GzLlM77zPnKemZ5p5zu+c/7fnfM9zHupRCVQClUAlUAlUApVAJVAJVAKVQFkC83CpbOTMSVuKe/gzc4ZcbqRr8aJT/MQB2I5PXcVPFIAj+DWl+IkA0MguFNvrU25yjWFSt+x6Fd/qO2Cq7CYKQC/ZTQyAfrJrPYBBsms1gGFk11oAw8quH4Dw+098w2e8xTM8xh1cxTkcxFYsx6xxWfFiZPc/ALH/vcNtnMVmzJ0OILGyiy0y5vqPuI6dmD9qGKmyiyko59r3OI8VowCRI7ucolLa/uj4Y2UpECVkl1JIbpsvOIOFOSCmS3a5xXe3f4r1KRDGSXbdBaV8/46jsctomwA00C5iTszdEKZAWGqagDacb8YumUGCz1sG4UbsnRCWwbstg3Al1gnj/iCUMj1PxPigubZNcgybsS1NYTHnUcjxd2c3eAsXcBh7OpuedViNZZ1PeMpbg03YjeO4jPv4GjlVwy50SUzxzbW5cnzd2cgcw0YsboIzz2GqbsApPEQAO2h6hK130pEjx6QOExqtwmm8HABiW0L2vyapckztL7XdbOzCgz4gwlIfakk+YuWY3FFmw/BWaQee9ABxKDNbjBxz+8ptH+6I/fjQBeINFuUGDyvH3H5KtQ8ry7UuCCdLBA8jxxL9lMzY29n3vCr1rnGQHEsOvlRWWDEeYV+pwJDTT44l+yiZtQAHSgaGrF5yLN3H2OdNlePYD3gUA+yW4yjyZ0RmI8cZMdg6yEqgEqgEKoFKoBKoBCqBSqASmCwCfwGgKYx/6VF/QQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequest);
export default __webpack_public_path__ + "static/media/request.38a3f1b60b19a7b7ea0a894edfb935ff.svg";
export { ForwardRef as ReactComponent };